import { Stack } from 'braid-design-system';
import type React from 'react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';

import type { ApplicationStatusFacets } from '../utils/getStatusFacetsFromQueryData';

import { StatusFolderButton } from './StatusFolderButton';

interface StatusFolderButtonsProps {
  selectedStatusFolder: BUCKETS | null;
  statusFacets: ApplicationStatusFacets;
  onClickStatusFolder: (bucket: BUCKETS) => void;
}

export const StatusFolderButtons: React.FC<StatusFolderButtonsProps> = ({
  selectedStatusFolder,
  onClickStatusFolder,
  statusFacets,
}) => (
  <Stack space="xxsmall" data={{ testid: 'status-folder-buttons' }}>
    <StatusFolderButton
      onClick={() => onClickStatusFolder(BUCKETS.INBOX)}
      count={statusFacets.inboxCount}
      newCount={statusFacets.newCount}
      isSelected={selectedStatusFolder === BUCKETS.INBOX}
      type={BUCKETS.INBOX}
    />
    <StatusFolderButton
      onClick={() => onClickStatusFolder(BUCKETS.PRESCREEN)}
      count={statusFacets.prescreenCount}
      newCount={null}
      isSelected={selectedStatusFolder === BUCKETS.PRESCREEN}
      type={BUCKETS.PRESCREEN}
    />
    <StatusFolderButton
      onClick={() => onClickStatusFolder(BUCKETS.SHORTLIST)}
      count={statusFacets.shortlistCount}
      newCount={null}
      isSelected={selectedStatusFolder === BUCKETS.SHORTLIST}
      type={BUCKETS.SHORTLIST}
    />
    <StatusFolderButton
      onClick={() => onClickStatusFolder(BUCKETS.INTERVIEW)}
      count={statusFacets.interviewCount}
      newCount={null}
      isSelected={selectedStatusFolder === BUCKETS.INTERVIEW}
      type={BUCKETS.INTERVIEW}
    />
    <StatusFolderButton
      onClick={() => onClickStatusFolder(BUCKETS.OFFER)}
      count={statusFacets.offerCount}
      newCount={null}
      isSelected={selectedStatusFolder === BUCKETS.OFFER}
      type={BUCKETS.OFFER}
    />
    <StatusFolderButton
      onClick={() => onClickStatusFolder(BUCKETS.ACCEPT)}
      count={statusFacets.acceptCount}
      newCount={null}
      isSelected={selectedStatusFolder === BUCKETS.ACCEPT}
      type={BUCKETS.ACCEPT}
    />
    <StatusFolderButton
      onClick={() => onClickStatusFolder(BUCKETS.NOT_SUITABLE)}
      count={statusFacets.rejectedCount}
      newCount={null}
      isSelected={selectedStatusFolder === BUCKETS.NOT_SUITABLE}
      type={BUCKETS.NOT_SUITABLE}
    />
  </Stack>
);
